import {ThemeProvider} from '@mui/material';
import theme from '../../theme';
import InvoiceDetailsComponent from './Component';

function InvoiceDetailsContainer() {
  return (
    <ThemeProvider theme={theme}>
      <InvoiceDetailsComponent />
    </ThemeProvider>
  );
}

export default InvoiceDetailsContainer;
